/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { Field, FieldProps } from 'formik'
import { useServiceContext } from '../../../../../root'
import { WF_STEP_TYPE } from './constants'
import SelectUserGroup from './SelectUserGroup'
import { ErrorMessageStyled } from '../../../../../components/shared/ErrorMessage'

interface RejectionReviewStepFormProps {
  values: any
  setFieldValue: (field: string, value: any) => void
}

const RejectionReviewStepForm: React.FC<RejectionReviewStepFormProps> = ({ values, setFieldValue }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter
  const rejectionReviewersType = values.rejectionReviewers?.type || WF_STEP_TYPE.USE_INITIATOR

  return (
    <>
      {/* Radio buttons for rejection reviewer type */}
      <div className="form-group">
        <Field name="rejectionReviewers.type">
          {({ field }: FieldProps) => (
            <>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`1c5f10d8-e4d7-4d5b-be00-7864ef173ab2-${WF_STEP_TYPE.USE_INITIATOR}`}
                    value={WF_STEP_TYPE.USE_INITIATOR}
                    checked={rejectionReviewersType === WF_STEP_TYPE.USE_INITIATOR}
                    onChange={() => setFieldValue('rejectionReviewers.type', WF_STEP_TYPE.USE_INITIATOR)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_REJECTION_REVIEWERS_LABEL_INITIATOR_OF_CR')}
                </label>
              </div>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`1c5f10d8-e4d7-4d5b-be00-7864ef173ab2-${WF_STEP_TYPE.USE_PREDEFINED}`}
                    value={WF_STEP_TYPE.USE_PREDEFINED}
                    checked={rejectionReviewersType === WF_STEP_TYPE.USE_PREDEFINED}
                    onChange={() => setFieldValue('rejectionReviewers.type', WF_STEP_TYPE.USE_PREDEFINED)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_REJECTION_REVIEWERS_LABEL_SPECIFIC_USERS')}
                </label>
              </div>
            </>
          )}
        </Field>
      </div>

      {/* Show SelectUserGroup only when USE_PREDEFINED is selected */}
      {rejectionReviewersType === WF_STEP_TYPE.USE_PREDEFINED && (
        <>
          <SelectUserGroup
            isMulti={true}
            value={values.rejectionReviewers?.usersGroups || []}
            onChange={(option) => {
              setFieldValue('rejectionReviewers.usersGroups', option ? option : [])
            }}
            name="rejectionReviewers.usersGroups"
          />
          <ErrorMessageStyled name="rejectionReviewers.usersGroups" />
        </>
      )}
    </>
  )
}

export default RejectionReviewStepForm
